module.exports = __webpack_public_path__ + "3c62314cf1d347db954e23d5a7c77758.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_6.jpg
// module id = 212
// module chunks = 1